import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Perform2023GallerySection = ({ data }) => {
    return (
        <div className="cp-perform2023Gallery">
            <div className="cp-perform2023Gallery__inner" data-aos="fade-up">
                {data.perform23GallerySectionHeader &&
                    <h2>{data.perform23GallerySectionHeader}</h2>
                }
                {data.perform23GallerySectionTeaser &&
                    <p>{data.perform23GallerySectionTeaser}</p>
                }
                {data.perform23GallerySectionImages &&
                    <div className="cp-perform2023Gallery__grid">
                        {data.perform23GallerySectionImages.map((speakers, index) => (
                            <div className="cp-perform2023Gallery__grid-speaker">
                                <GatsbyImage className="l--borderRadiusLarge" image={getImage(speakers.gatsbyImage)} alt={speakers.altText} />
                            </div>
                        ))}
                    </div>
                }
                {data.perform23GallerySectionButton &&
                    <div className="l-buttonWrap">
                        <div className="l-relativeButton">
                            <a className="l-button" href={data.perform23GallerySectionButton.url} target={data.perform23GallerySectionButton.target}>{data.perform23GallerySectionButton.title}</a>
                            <a className="l-button l-backgroundHover" href={data.perform23GallerySectionButton.url} target={data.perform23GallerySectionButton.target}>{data.perform23GallerySectionButton.title}</a>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
export default Perform2023GallerySection;

